<mat-card>
  <form [formGroup]="">
    <div fxLayout="column" fxLayoutGap="20px">

      <div *ngIf="profile?.userId" fxLayout="row" fxLayoutGap="15px">

        <button *ngIf="(userPermissions | async).marketing.write"
                (click)="modify()" mat-stroked-button color="primary">
          <mat-icon>create</mat-icon> <span> Edytuj</span>
        </button>
        <button *ngIf="(userPermissions | async).marketing.delete"
                (click)="delete()" mat-stroked-button color="warn">
          <mat-icon>delete</mat-icon> <span> Usuń</span>
        </button>
      </div>

      <div class="id-info">
        <mat-form-field appearance="fill" color="accent">
          <mat-label>ID</mat-label>
          <input matInput placeholder="ID" [disabled]="true" [value]="warehouseProductObject?.recordId?.toString()">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start">

        <div fxFlex="100" fxLayout="row" fxLayoutGap="20px">

          <mat-card fxFlex="50">
            <h3>Dane produktu</h3>

            <div>
              <div class="user-avatar" *ngIf="warehouseProductObject?.filename"
                   matRipple
                   [matRippleCentered]="false"
                   [matRippleDisabled]="false"
                   [matRippleUnbounded]="false"
                   [matRippleRadius]="10"
                   [matRippleColor]="'grey'" >
                <img src="/rest/crm/product/{{warehouseProductObject.uuid}}/image?{{imgCnt}}" alt="Zdjęcie" height="60"/>
              </div>
              <div>
                <span fxFlex></span>
              </div>
              <input #imageSelect type="file" style="display: none" [formControl]="imageSelectControl"
                     accept=".jpg,.gif,.png,.jpeg"/>
            </div>

            <div fxLayout="column" fxLayoutGap="10px">
              <div fxLayout="row" fxLayoutGap="10px">
                <app-detail fxFlex="100" header="Kategoria"
                            [value]="warehouseProductObject?.category?.name">
                </app-detail>

                <app-detail fxFlex="100" header="Nazwa produktu"
                            [value]="warehouseProductObject?.productName">
                </app-detail>
              </div>

              <div fxLayout="row" fxLayoutGap="10px">
                <app-detail fxFlex="100" header="Ilość produktu"
                            [value]="warehouseProductObject?.productAmount?.toString()">
                </app-detail>

                <app-detail fxFlex="100" header="Magazyn"
                            [value]="warehouseProductObject?.warehouse?.name">
                </app-detail>
              </div>

              <app-detail-bool header="Wymagany protokół"
                               [value]="warehouseProductObject?.protocol">
              </app-detail-bool>
            </div>
          </mat-card>

          <mat-card fxFlex="50">
            <h3>Dane zakupu</h3>

            <div fxLayout="column" fxLayoutGap="10px">
              <div fxLayout="row" fxLayoutGap="10px">
                <app-detail fxFlex="100" header="Cena jednostkowa zakupu"
                            [value]="warehouseProductObject?.productPrice?.toString()?.replace('.', ',')">
                </app-detail>

                <app-detail fxFlex="100" header="Firma"
                            [value]="warehouseProductObject?.company?.name">
                </app-detail>
              </div>

              <div fxLayout="row" fxLayoutGap="10px">

                <app-detail fxFlex="50" header="Data zakupu"
                            [value]="warehouseProductObject?.purchaseDate | date:'yyyy-MM-dd':'UTC'">
                </app-detail>

                <app-detail fxFlex="50" header="Data ważności"
                            [value]="warehouseProductObject?.expirationDate | date:'yyyy-MM-dd':'UTC'">
                </app-detail>
              </div>

            </div>
          </mat-card>

        </div>

      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap="10px">
        <mat-card fxFlex="50">
          <div>
            <h3>Uwagi</h3>
            <app-detail header="Uwagi"
                        [value]="warehouseProductObject?.note">
            </app-detail>
          </div>
        </mat-card>
      </div>
    </div>
  </form>
</mat-card>
